import React, { useState, useEffect } from "react";
import "./Position.scss";
import SourceImage from "../SourceImage/SourceImage";
import topImage from "../../resources/images/placeholder-4.png";
import { formatData, isEmptyString } from "../../helperFunc";

const UNDESIRED_COLUMNS = [
  "id",
  "metadata_id",
  "source_name",
  "source_id",
  "pointing_name",
];
function Position({ data, isPositionLoading }) {
  const [imageArray, setImageArray] = useState([]);
  const [pointingData, setPointingData] = useState({});
  const [selectedSpectralWindow, setSelectedSpectralWindow] = useState("");
  const [selectedBand, setSelectedBand] = useState("");
  const [filterMap, setFilterMap] = useState({});
  const [imagesWithLabels, setImagesWithLabels] = useState({});

  useEffect(() => {
    if (!isPositionLoading && data) {
      let { artefacts, display_order, reference_spw, reference_freq } = data.images;
      let otherImages = [];
      display_order.forEach((spw) => {
        const ref_freq =
          reference_freq[spw] !== undefined
            ? reference_freq[spw].toFixed(2)
            : "NA";
        const image = {
          src: artefacts[spw].cutout_png,
          alt: "",
          label: `${spw}: ${ref_freq}`,
          fits: artefacts[spw].cutout_fits,
        };

        setImagesWithLabels((prevImageData) => {
          return {
            ...prevImageData,
            [spw]: image,
          };
        });

        otherImages.push(image);
      });

      setImageArray(otherImages);
      setPointingData(data.pointing);
      const map = {};
      Object.keys(data.pointing || {}).forEach((key, i) => {
        const subKeys = Object.keys(data.pointing[key]);
        if (i === 0) {
          setSelectedBand(key);
          setSelectedSpectralWindow(subKeys[0]);
        }
        map[key] = subKeys;
      });
      setFilterMap(map);
    }
  }, [data, isPositionLoading]);

  function createColumnNameWithUnits(field) {
    let text = field.replaceAll("_", " "),
      unit = "";
    if (field in data.units) {
      text = data.units[field].text || text;

      if (
        "unit" in data.units[field] &&
        !isEmptyString(data.units[field]["unit"])
      ) {
        unit = `(${data.units[field].unit})`;
      }
    }

    return (
      <span>
        <b>{text}</b>
        <span className="column-unit">{unit}</span>
      </span>
    );
  }

  function handleBandChange(e) {
    const { value } = e.target;
    setSelectedBand(value);
    setSelectedSpectralWindow(filterMap[value][0]);
  }

  function handleSPWChange(e) {
    const { value } = e.target;
    setSelectedSpectralWindow(value);
  }

  return (
    <div className="position">
      <div className="data-filter">
        <div className="filters">
          <label>
            <span>Observation Band</span>
            <div className="select-wrapper">
              <select
                name="band"
                onChange={handleBandChange}
                value={selectedBand}
              >
                {Object.keys(filterMap).map((value) => (
                  <option value={value} key={value}>
                    {value}
                  </option>
                ))}
              </select>
            </div>
          </label>
          <label>
            <span>Spectral Window</span>
            <div className="select-wrapper">
              <select
                name="spectral-window"
                onChange={handleSPWChange}
                value={selectedSpectralWindow}
              >
                {filterMap[selectedBand]?.map((value) => (
                  <option value={value} key={value}>
                    {value}
                  </option>
                ))}
              </select>
            </div>
          </label>
        </div>
      </div>
      <>
        <div className="position-container">
          <div className="left-panel">
            <SourceImage
              data={
                selectedBand &&
                selectedSpectralWindow &&
                imagesWithLabels[selectedSpectralWindow]
                  ? imagesWithLabels[selectedSpectralWindow]
                  : { src: topImage, alt: "" }
              }
            />
            <div className="pointing-details">
              {selectedBand && selectedSpectralWindow ? (
                <>
                  <h3>
                    {
                      pointingData[selectedBand][selectedSpectralWindow]
                        .pointing_name
                    }
                  </h3>
                  {Object.keys(
                    pointingData[selectedBand][selectedSpectralWindow]
                  )
                    .filter((el) => !UNDESIRED_COLUMNS.includes(el))
                    .map((field) => {
                      return (
                        <p key={field}>
                          <b>{createColumnNameWithUnits(field)}</b>
                          {formatData(
                            field,
                            pointingData[selectedBand][selectedSpectralWindow][
                              field
                            ]
                          )}
                        </p>
                      );
                    })}
                </>
              ) : (
                "Loading content"
              )}
            </div>
          </div>
          <div className="image-panel">
            {imageArray.length > 0 ? (
              <div className="images">
                {imageArray.map((img, idx) => (
                  <SourceImage key={idx} data={img} />
                ))}
              </div>
            ) : (
              <></>
            )}
          </div>
        </div>
      </>
    </div>
  );
}

export default Position;
